module.exports = __webpack_public_path__ + "img/newYearBg.a7d6fe1c.png";